import React from "react";
import { NavLink } from "react-router-dom";
import { Home, ClipboardList, Bell, UserCircle, Wallet } from "lucide-react";
import { useTranslation } from "react-i18next";

const tabs = [
    { to: "/field", label: "Home", labelKey: "nav.home", icon: Home, end: true },
    { to: "/field/tasks", label: "Tasks", labelKey: "nav.tasks", icon: ClipboardList },
    { to: "/field/payroll", label: "Payroll", labelKey: "nav.payroll", icon: Wallet },
    { to: "/field/alerts", label: "Alerts", labelKey: "nav.alerts", icon: Bell },
    { to: "/field/profile", label: "Profile", labelKey: "nav.profile", icon: UserCircle },
];

export default function EmployeeBottomNav() {
    const { t } = useTranslation();
    return (
        <nav className="fixed bottom-0 left-0 right-0 z-40 border-t border-border bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/80 lg:hidden">
            <div className="grid grid-cols-5 px-1 py-1">
                {tabs.map(({ to, label, labelKey, icon: Icon, end }) => (
                    <NavLink
                        key={to}
                        to={to}
                        end={end}
                        className={({ isActive }) =>
                            `flex flex-col items-center justify-center gap-1 rounded-xl py-2 text-[11px] font-medium transition-colors ${
                                isActive ? "text-primary" : "text-muted-foreground"
                            }`
                        }
                        data-testid={`employee-nav-${label.toLowerCase()}`}
                    >
                        <Icon className="w-5 h-5" />
                        <span>{t(labelKey, label)}</span>
                    </NavLink>
                ))}
            </div>
        </nav>
    );
}
